module.exports = __webpack_public_path__ + "media/images/common/sns/twitter-81dd5c0f0b9e6ac01c69df607cadf838.svg";